import React from 'react';
import { Modal } from 'antd';
import { useFormContext } from 'react-hook-form';
import { AlertSuccess } from '../../../../util/Alert';
import { useQueryClient } from '@tanstack/react-query';
import fitMissionServices from '../../../../../services/fit-mission.services';
import LegacyRewardForm from '../form/LegacyRewardForm';

const LegacyRewardModal = ({ open, handleClose }) => {
  const { watch, handleSubmit } = useFormContext();
  const queryClient = useQueryClient();

  const { mutate: createReward } =
    fitMissionServices.useMutationCreateMissionReward(() => {
      queryClient.invalidateQueries({
        queryKey: ['get-mission-reward'],
        refetchType: 'all',
      });
      AlertSuccess('เพิ่มข้อมูลสำเร็จ');
      handleClose();
    });

  const { mutate: editReward } =
    fitMissionServices.useMutationUpdateMissionReward(() => {
      queryClient.invalidateQueries({
        queryKey: ['get-mission-reward'],
        refetchType: 'all',
      });
      AlertSuccess('แก้ไขข้อมูลสำเร็จ');
      handleClose();
    });

  const _HandleSubmit = handleSubmit((data) => {
    const rewardData = {
      title: data.title,
      image: data.image,
      point: Number(data.point),
      stockQuantity: Number(data.stockQuantity),
      sku: data.sku,
      memberType: data.memberType,
    };

    if (watch('formType') === 'create') {
      createReward(rewardData);
    } else if (watch('formType') === 'edit') {
      editReward({ id: data.id, data: rewardData });
    }
  });

  return (
    <Modal
      title={
        watch('formType') === 'create'
          ? 'เพิ่มสินค้าแลกคะแนน'
          : 'แก้ไขสินค้าแลกคะแนน'
      }
      visible={open}
      onCancel={handleClose}
      okText="บันทึก"
      cancelText="ยกเลิก"
      onOk={_HandleSubmit}
      width={'50vw'}
    >
      <LegacyRewardForm />
    </Modal>
  );
};

export default LegacyRewardModal;
